<div class="close-dialog-holder close-dialog-holder--with-title">
  <h2>
    {{
      'invite-signup-process-details.component.verify_identity_header'
        | localise: 'Verify your identity'
    }}
  </h2>
  <button
    mat-icon-button
    [mat-dialog-close]="false"
    type="button"
    class="close-dialog-button">
    <mat-icon>clear</mat-icon>
  </button>
</div>

@if (inviteSignupProcessService.detailsForm; as form) {
  <form [formGroup]="form" (ngSubmit)="next()">
    <mat-dialog-content>
      <p>
        {{
          'invite-signup-process-details.component.required_to_verify_identity'
            | localise
              : 'Because we are providing access to your commission, we are required to verify your identity.'
        }}
      </p>
      @if (form.controls.mls) {
        <mat-form-field class="full-width">
          <mat-label>{{
            'invite-signup-process-details.component.real_estate_license_number'
              | localise: 'Real Estate License Number'
          }}</mat-label>
          <input
            matInput
            appDisableAutofill
            formControlName="mls"
            #ctrl="ngControl" />
          @if (ctrl.errors?.server; as err) {
            <mat-error>{{ err }}</mat-error>
          }
        </mat-form-field>
      }
      @if (form.controls.ssn) {
        <mat-form-field class="full-width">
          <mat-label>{{
            'invite-signup-process-details.component.last_4_digits_ssn'
              | localise: 'Last 4 digits of SSN'
          }}</mat-label>
          <input
            matInput
            appDisableAutofill
            formControlName="ssn"
            mask="0000"
            #ctrl="ngControl" />
          @if (ctrl.errors?.server; as err) {
            <mat-error>{{ err }}</mat-error>
          }
        </mat-form-field>
      }
      @if (form.controls.dateOfBirth) {
        <app-day-input
          class="full-width"
          label="{{
            'invite-signup-process-details.component.date_of_birth_label'
              | localise: 'Date of Birth'
          }}"
          startView="multi-year"
          formControlName="dateOfBirth"
          #ctrl="ngControl"
          [max]="globalConstants.maxDobValue"
          [errors]="[
            ctrl.errors?.under18YearsOld && 'Minimum age of 18 years',
            ctrl.errors?.server,
          ]"
          [appDisableAutofill]="true"></app-day-input>
      }
      @if (error) {
        <p class="p-error-message p-error-message--margin">
          {{ error }}
        </p>
      }
    </mat-dialog-content>
    <div class="actions" mat-dialog-actions>
      <button
        mat-button
        type="button"
        (click)="inviteSignupProcessService.close.next()">
        {{
          'invite-signup-process-details.component.close_button'
            | localise: 'Close'
        }}
      </button>
      <button
        type="submit"
        class="p-button p-button--rounded p-button--application-next"
        [disabled]="loading || form.invalid">
        {{
          'invite-signup-process-details.component.complete_button'
            | localise: 'Complete'
        }}
      </button>
    </div>
  </form>
}
